(function () {
  function cmToInches(cm) {
    return (Math.round((cm / 2.54) * 10) / 10).toFixed(1);
  }

  function extractHeight(text) {
    var match = text.match(/(\d+(?:\.\d+)?)\s*cm/i);
    if (!match) return null;
    var cm = parseFloat(match[1]);
    return cm + 'cm (' + cmToInches(cm) + '")';
  }

  function initBadge() {
    var badge = document.querySelector('[data-height-badge]');
    var variantSelects = document.querySelector('variant-selects');
    if (!badge || !variantSelects || badge.dataset.heightBadgeInit) return;
    badge.dataset.heightBadgeInit = 'true';

    variantSelects.addEventListener('change', function (event) {
      var input = event.target;
      if (!input || input.tagName !== 'INPUT') return;

      var height = extractHeight(input.value);
      if (height) {
        badge.textContent = height + ' Height Boost';
        badge.style.display = '';
      }
    });
  }

  function appendInchesToVariantLabels() {
    var labels = document.querySelectorAll('variant-selects label');
    labels.forEach(function (label) {
      if (label.dataset.inchAppended) return;

      var text = label.textContent.trim();
      var match = text.match(/^(.*?)(\d+(?:\.\d+)?)\s*cm$/i);
      if (!match) return;

      var prefix = match[1];
      var cm = parseFloat(match[2]);
      label.textContent = prefix + cm + 'cm (' + cmToInches(cm) + '")';
      label.dataset.inchAppended = 'true';
    });
  }

  function init() {
    initBadge();
    appendInchesToVariantLabels();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
